import { colors } from '@styles/vars/colors.style'
import {
  getCustomTextStyle,
  TextBody,
  textStylesConfig,
} from '@styles/vars/textStyles.style'
import styled from 'styled-components'

export const BrandsMain = styled.section`
  background-color: ${colors.white};

  ${TextBody} {
    ${getCustomTextStyle(
      textStylesConfig.heading2Serif,
      textStylesConfig.heading1Serif
    )}
  }
`

export const BrandsImage = styled.div`
  max-height: 50px;
  [data-main-image] {
    object-fit: contain !important;
    max-height: 50px;
  }
`
